(function () {
  function initBundleSelector(container) {
    const grid = container.querySelector('.lp-bundle-selector__grid');
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll('.lp-bundle-selector__card'));
    if (!cards.length) return;

    function setActiveCard(card) {
      cards.forEach(function (c) {
        c.classList.toggle('is-selected', c === card);
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        // Let the card's own interactive controls (quick add, swatches) behave normally.
        if (e.target.closest('quick-add, mobile-quick-add, product-swatch')) return;
        activateCard(card, e);
      });

      card.addEventListener('keydown', function (e) {
        if (e.target.closest('quick-add, mobile-quick-add, product-swatch')) return;
        if (e.key !== 'Enter' && e.key !== ' ') return;
        activateCard(card, e);
      });
    });

    function activateCard(card, e) {
      const productUrl = card.getAttribute('data-product-url');
      if (!productUrl) return;
      if (card.classList.contains('is-selected')) {
        e.preventDefault();
        return;
      }

      e.preventDefault();
      setActiveCard(card);
      card.classList.add('lp-bundle-selector__card--loading');

      if (typeof window.loadMainProductSet !== 'function') return;

      window.loadMainProductSet(productUrl).then(function () {
        card.classList.remove('lp-bundle-selector__card--loading');
        const mainProductSet = document.querySelector('.lp-main-product-set');
        if (mainProductSet) {
          const topOffset = mainProductSet.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: topOffset, behavior: 'smooth' });
        }
      });
    }
  }

  document.querySelectorAll('[data-lp-bundle-selector]').forEach(initBundleSelector);
})();
